import { UntypedFormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

const validateEmail = (value?: string | null): { email: true } | null => {
  const EMAIL_PATTERN =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return isEmpty(value) || EMAIL_PATTERN.test(value) ? null : { email: true };
};

export const emailValidator = (control: UntypedFormControl) => validateEmail(control.value);
export const emailTrimValidator = (control: UntypedFormControl) =>
  validateEmail(control.value && control.value.trim());
